import * as moment from 'moment';

export class MasterSheetFilter {
  fromDate: moment.Moment;
  toDate: moment.Moment;
}

